import { useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { useParams } from "react-router-dom";
import { useEffect } from "react";
import Swal from "sweetalert2";
// import $ from "jquery";
import Breadcrums from "../../common/breadcrumbs";
import Loader from "../../common/loader";
import StatusFilter from "../../common/statusFilter";
import { SWAL_SETTINGS, showFilterlist } from "../../../../utils/Constants";
import { TrimText, capitalizeFirstLetter, formateDateWithMonth, formateDateWithMonthAdmin, handleServerValidations, writeMyExcel, usePermission } from "../../../../utils/commonfunction";
import CustomPagination from "../../common/custompagination";
import Sorting from "../../common/sorting";
import * as usersService from "../../services/customer.services";
import * as userMgmtService from "../../services/usermgmt.services";
import { useTranslation } from "react-i18next";
import CustomRangepicker from "../../common/rangepicker";
import { Placeholder, Tooltip, Whisper } from "rsuite";
import UserManagementTabs from "../../common/userManagementTabs";
import AvatarImage from "../../../user/components/AvatarImage";

const APP_UPDATE_NOTIFICATION = {
  title: "New Version Available",
  body: "A new version of The Live Shop app has been published. Please download the latest update from the App Store / Play Store to continue enjoying new features and improvements.",
};

const UsersList = () => {
  const { can } = usePermission();
  const params = useParams();
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const showSendNotification = searchParams.get("notify") === "true";
  const [list, setList] = useState([]);
  const [statsupdate, setStatusUpdate] = useState("false");
  const [datalength, setDataLength] = useState();
  const [itemperpage] = useState(10);
  const [sorting, setSorting] = useState({});
  const [defaultSorting, setDefaultSorting] = useState(true);
  const [page, setPage] = useState(1);
  const [loader, setLoader] = useState(true);
  const [search, setSearch] = useState({});
  const [globalsearch, setGlobalSearch] = useState("");
  const [sendingNotification, setSendingNotification] = useState(false);
  const breadcrumbs = [
    { title: t("sidebar_link_dashboard"), url: "/admin/dashboard" },
    { title: "User Management", url: "" },
  ];
  const [resetdate, setResetDate] = useState(false);

  useEffect(() => {
    const getData = setTimeout(() => {
      if (search) {
        setLoader(true);
        const formData = new FormData();
        formData.append("page", params.pgno);
        formData.append("per_page", itemperpage);
        formData.append("sort", JSON.stringify(sorting));
        formData.append("search", JSON.stringify(search));
        formData.append("global_search", globalsearch);
        usersService
          .List(formData)
          .then((data) => {
            setDataLength(data.data.total_records);
            setList(data && data.data && data.data.list ? data.data.list : []);
            setLoader(false);
          })
          .catch((error) => {
            console.log("error ====> ", error);
          });
      }
    }, 300);

    return () => clearTimeout(getData);
  }, [location, statsupdate, sorting, search, globalsearch, params.pgno, globalsearch]);

  const viewfunction = (row) => {
    navigate(`/admin/customers/view/${row._id}`);
  };

  const Editfunction = (row) => {
    navigate(`/admin/customers/edit/${row._id}`);
  };

  const ChangeStatus = (data, Num) => {
    const formData = new FormData();
    formData.append("_id", data);
    formData.append("status", Num);
    Swal.fire({
      customClass: "swal-wide",
      title: t("msg_are_you_sure"),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#403fad",
      cancelButtonColor: "#f1388b",
      confirmButtonText: t("btn_yes"),
      cancelButtonText: t("btn_cancel"),
    }).then((result) => {
      if (result.isConfirmed) {
        usersService
          .Status(formData)
          .then((response) => {
            if (response.success) {
              Swal.fire({
                icon: "success",
                text: response.message,
                ...SWAL_SETTINGS,
              });
              setStatusUpdate(!statsupdate);
            } else {
              Swal.fire({
                icon: "error",
                text: handleServerValidations(response),
                ...SWAL_SETTINGS,
              });
            }
          })
          .catch((error) => {
            console.log("error===>");
          });
      }
    });
  };

  const handleSort = (e, column) => {
    setDefaultSorting(false);
    let sort = { order: 0, column: column };
    if (e.target.classList.contains("assc")) {
      sort.order = -1;
    } else {
      sort.order = 1;
    }
    setSorting(sort);
  };

  // search or filter function
  const prepareSearch = (key, value) => {
    let sr = { ...search };
    if (String(value).length > 0) {
      sr[key] = value;
    } else {
      delete sr[key];
    }
    setSearch(sr);
  };
  // search or filer end

  const resetFilter = (e) => {
    e.preventDefault();
    setGlobalSearch("");
    prepareSearch();
    setSearch({});
    // reset customrangepicker & customstatusfilter state using jquery//
    setResetDate(!resetdate);

  };

  const handleSendNotification = () => {
    Swal.fire({
      customClass: "swal-wide",
      title: t("msg_are_you_sure"),
      text: "Send app update notification to all users?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#403fad",
      cancelButtonColor: "#f1388b",
      confirmButtonText: t("btn_yes"),
      cancelButtonText: t("btn_cancel"),
    }).then((result) => {
      if (result.isConfirmed) {
        setSendingNotification(true);
        userMgmtService
          .SendNotification(APP_UPDATE_NOTIFICATION)
          .then((response) => {
            if (response.success) {
              Swal.fire({
                icon: "success",
                text: response.message,
                ...SWAL_SETTINGS,
              });
            } else {
              Swal.fire({
                icon: "error",
                text: handleServerValidations(response),
                ...SWAL_SETTINGS,
              });
            }
          })
          .catch((error) => {
            console.log("sendNotificationError", error);
            Swal.fire({
              icon: "error",
              text: "Failed to send notification",
              ...SWAL_SETTINGS,
            });
          })
          .finally(() => {
            setSendingNotification(false);
          });
      }
    });
  };

  function Deletefunction(data) {
  
    Swal.fire({
      customClass: "swal-wide",
      title: t("msg_are_you_sure"),
      text: t("you_not_be_able_to_revert_this"),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#403fad",
      cancelButtonColor: "#f1388b",
      confirmButtonText: t("Delete"),
      cancelButtonText: t("Cancel"),
    }).then((result) => {
      if (result.isConfirmed) {
        usersService
          .Delete({_id : data})
          .then((response) => {
            if (response.success) {
              Swal.fire({
                icon: "success",
                text: response.message,
                ...SWAL_SETTINGS,
              });
              setStatusUpdate(!statsupdate);
            } else {
              Swal.fire({
                icon: "error",
                text: handleServerValidations(response),
                ...SWAL_SETTINGS,
              });
            }
          })
          .catch((error) => {
            console.log("deleteError");
          });
      }
    });
  }

  const handleExportToExcel = () => {
    // Prepare the data for export
    const headers = ["Full Name", "Email", "Phone Number", "Address", "Created At", "Status"];

    const rows = list.map((row) => [
      row?.fullName ? capitalizeFirstLetter(row.fullName) : "N/A",
      row?.email ? row.email : "N/A",
      row?.phone_number ? row?.phone_number?.fullNumber : "N/A",
      row?.address ? capitalizeFirstLetter(row.address) : "N/A",
      row?.createdAt ? formateDateWithMonth(row.createdAt) : "N/A",
      row.status === 1 ? "Active" : "Inactive",
    ]);

    writeMyExcel([headers, ...rows], `${t("label_rating_report")}.xlsx`);
  };

  return (
    <>
      <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
        <Breadcrums data={breadcrumbs} />
        {showSendNotification && (
          <button
            type="button"
            className="btn btn-sm ripple btn-main-primary signbtn"
            style={{ padding: "4px 12px", fontSize: "12px", whiteSpace: "nowrap" }}
            onClick={handleSendNotification}
            disabled={sendingNotification}
          >
            {sendingNotification ? "Sending..." : "Send Notification"}
          </button>
        )}
      </div>
      <UserManagementTabs />
      {/* table section */}
      <div className="animation_fade">
        <div className="card custom-card overflow-hidden">
          <div className="card-body">
            <div className="d-flex justify-content-between align-items-center mb-4">
              <h6 className="main-content-label">User Management</h6>
              <div className="d-flex align-items-center">
                <div className="form-group mb-0 me-3">
                  <div className="form-group mb-0 rangepicker_container filter_design">
                    <i className="fa fa-search calender_icon"></i>
                    <input
                      type="search"
                      className="form-control"
                      value={globalsearch}
                      placeholder={t("Search")}
                      onChange={(e) => {
                        setGlobalSearch(e.target.value);
                      }}
                    />
                  </div>
                </div>
                <div className="me-3">
                  <CustomRangepicker
                    GetDateRange={(e) => {
                      prepareSearch("createdAt", e);
                    }}
                    resetdate={resetdate}
                  />
                </div>
                <div className="me-3">
                  <div className="form-group mb-0 filter_icon_container filter_design">
                    <i className="fa fa-filter mr-2 filter_icon"></i>
                    <div className="select-down-arrow">
                      <select
                        className="form-control cp"
                        value={search.is_email_verified !== undefined ? search.is_email_verified : ""}
                        onChange={(e) => prepareSearch("is_email_verified", e.target.value)}
                      >
                        <option value="">All (Email Status)</option>
                        <option value="1">Verified</option>
                        <option value="0">Unverified</option>
                      </select>
                    </div>
                  </div>
                </div>
                <button type="reset" value="Reset" onClick={resetFilter} className="btn btn-warning float-right mr-2 ripple">
                  {t("Reset filter")}
                </button>
                {/* <button type="" value="" class="btn ripple btn-main-primary signbtn" onClick={() => handleExportToExcel()}>
                  Export Report
                </button> */}
              </div>
            </div>
            {
              loader?
              <Placeholder.Paragraph className="w-100" rowHeight={30} rowSpacing={5} active={true} rows={7}/>
              :
              <>
            <div className="table-responsive min-h-400">
              <table id="example-input" className="table table-bordered card-table border-top text-nowrap w-100">
                {/* <table id="example-input" className="table table-bordered border-t0 key-buttons text-nowrap w-100"> */}
                <thead>
                  <tr>
                    <th className="sr_head">S.NO.</th>
                    <th>
                      <div className="sorting_column">
                        <span>Name</span>
                        <Sorting sort={sorting} handleSort={handleSort} column="name" />
                      </div>
                    </th>
                    <th>
                      <div className="sorting_column">
                        <span>Email</span>
                        <Sorting sort={sorting} handleSort={handleSort} column="email" />
                      </div>
                    </th>
                    <th>
                      <div className="sorting_column">
                        <span>Phone Number</span>
                        <Sorting sort={sorting} handleSort={handleSort} column="phone_number" />
                      </div>
                    </th>
                    <th>
                      <div className="sorting_column">
                        <span>Address</span>
                        <Sorting sort={sorting} handleSort={handleSort} column="address" />
                      </div>
                    </th>
                    <th className="created_head">
                      <div className="sorting_column">
                        <span>{t("Created Date")}</span>
                        <Sorting sort={sorting} defaultSorting={defaultSorting} handleSort={handleSort} column="createdAt" />
                      </div>
                    </th>
                    <th>
                      <div className="sorting_column">
                        <span>Last Login</span>
                        <Sorting sort={sorting} handleSort={handleSort} column="last_login_at" />
                      </div>
                    </th>
                    <th className="status_head">{t("Status")}</th>
                    <th className="action_head">{t("Action")}</th>
                  </tr>
                </thead>
                <tbody>
                  {/* {loader ? (
                      <Placeholder.Paragraph className="w-100" rowHeight={30} rowSpacing={5} active={true} rows={7}/>
                  ) : (
                    <> */}
                      {list.length ? (
                        list.map((row, i) => {
                          return (
                            <tr key={i}>
                              <td>{row ? (page - 1) * itemperpage + i + 1 : null}</td>
                              <td>
                                <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                  <AvatarImage
                                    src={row?.profile_image}
                                    name={row?.name}
                                    style={{
                                      width: "36px",
                                      height: "36px",
                                      borderRadius: "50%",
                                      objectFit: "cover",
                                      fontSize: "14px",
                                      minWidth: "36px",
                                    }}
                                  />
                                  <span>{capitalizeFirstLetter(row?.name) || "N/A"}</span>
                                </div>
                              </td>
                              <td>
                                <div className="d-flex flex-column" style={{ gap: "4px" }}>
                                  <span style={{ fontWeight: 500 }}>{row?.email || "N/A"}</span>
                                  {row?.email ? (
                                    row?.is_email_verified ? (
                                      <span
                                        className="badge bg-success-transparent text-success border border-success"
                                        style={{
                                          width: "fit-content",
                                          fontSize: "11px",
                                          padding: "2px 8px",
                                          borderRadius: "12px",
                                          display: "inline-flex",
                                          alignItems: "center",
                                          gap: "4px",
                                        }}
                                      >
                                        <i className="ri-checkbox-circle-fill" style={{ fontSize: "12px" }}></i> Verified
                                      </span>
                                    ) : (
                                      <span
                                        className="badge bg-danger-transparent text-danger border border-danger"
                                        style={{
                                          width: "fit-content",
                                          fontSize: "11px",
                                          padding: "2px 8px",
                                          borderRadius: "12px",
                                          display: "inline-flex",
                                          alignItems: "center",
                                          gap: "4px",
                                        }}
                                      >
                                        <i className="ri-close-circle-fill" style={{ fontSize: "12px" }}></i> Unverified
                                      </span>
                                    )
                                  ) : null}
                                </div>
                              </td>
                              <td>{row?.phone_number ? row?.phone_number : "N/A"}</td>
                              <td>{capitalizeFirstLetter(row?.address) || "N/A"}</td>
                              <td>{row?.createdAt ? formateDateWithMonthAdmin(row.createdAt) : "N/A"}</td>
                              <td>
                                {row?.last_login_at ? (
                                  <div className="d-flex flex-column" style={{ gap: "3px", fontSize: "12px" }}>
                                    <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                                      <span className="badge bg-primary-transparent text-primary" style={{ fontFamily: "monospace", fontSize: "11px", padding: "2px 6px" }}>
                                        <i className="ri-computer-line me-1"></i>
                                        {row?.last_login_ip || "N/A"}
                                      </span>
                                    </div>
                                    <div className="text-muted" style={{ fontSize: "11px", display: "flex", alignItems: "center", gap: "4px" }}>
                                      <i className="ri-map-pin-line text-secondary"></i>
                                      <span>
                                        {typeof row?.last_login_location === "object"
                                          ? row?.last_login_location?.formatted || row?.last_login_location?.country || "Local Network"
                                          : row?.last_login_location || "Local Network"}
                                      </span>
                                    </div>
                                    <div className="text-muted" style={{ fontSize: "11px" }}>
                                      <i className="ri-time-line me-1"></i>
                                      {formateDateWithMonthAdmin(row.last_login_at)}
                                    </div>
                                  </div>
                                ) : (
                                  <span className="text-muted" style={{ fontSize: "12px", fontStyle: "italic" }}>
                                    Never logged in
                                  </span>
                                )}
                              </td>
                              <td>
                                <label className={"custom-switch cp" + (row.status !== 1 ? " e_none" : "")}>
                                  <input
                                    className="custom-switch-input cp"
                                    type="checkbox"
                                    checked={row?.status === 1}
                                    disabled={!can("/admin/customers/status") && !can("/admin/customers/edit")}
                                    onChange={() => (can("/admin/customers/status") || can("/admin/customers/edit")) && ChangeStatus(row?._id, row?.status === 1 ? 0 : 1)}
                                  />
                                  <span className="custom-switch-indicator cp"></span>
                                </label>
                              </td>
                              <td>
                                <div className="btn-toolbar table-actions" role="toolbar" aria-label="Toolbar with button groups">
                                  <div className="btn-group btn-group-sm" role="group" aria-label="Second group">
                                    <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={<Tooltip style={{ fontWeight: "bold" }}>View</Tooltip>}>
                                      <button
                                        type="button"
                                        className="btn view"
                                        onClick={() => {
                                          viewfunction(row);
                                        }}>
                                        <i className="ri-eye-fill"></i>
                                      </button>
                                    </Whisper>
                                    {/* {can("/admin/customers/edit") && (
                                      <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={<Tooltip style={{ fontWeight: "bold" }}>Edit</Tooltip>}>
                                        <button
                                          type="button"
                                          className="btn edit"
                                          onClick={() => {
                                            Editfunction(row);
                                          }}>
                                          <i className="ri-pencil-fill"></i>
                                        </button>
                                      </Whisper>
                                    )} */}
                                    {can("/admin/customers/delete") && (
                                      <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={<Tooltip style={{ fontWeight: "bold" }}>Delete</Tooltip>}>
                                        <button
                                          type="button"
                                          className="btn delete"
                                          onClick={() => {
                                            Deletefunction(row?._id);
                                          }}>
                                          <i className="ri-delete-bin-6-fill"></i>
                                        </button>
                                      </Whisper>
                                    )}
                                  </div>
                                </div>
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan={13} className="text-center">
                            {t("msg_no_records")}
                          </td>
                        </tr>
                      )}
                    {/* </>
                  )} */}
                </tbody>
              </table>
            </div>
            <div className="" id="example1_info" role="status" aria-live="polite">
              <b>
                {t("msg_total_records")} : {datalength ? datalength : "0"}
              </b>
            </div>
            {datalength && datalength > 0 ? (
              <CustomPagination datalength={datalength} itemperpage={itemperpage} setPage={setPage} currentPage={page} pageRoute={[{ name: "User", path: "/admin/customers/list" }]} />
            ) : (
              ""
            )}
              </>
             }
          </div>
          <div></div>
        </div>
      </div>
    </>
  );
};

export default UsersList;
